// import type {WebInterface} from '@byted-sdk/account-api';

// 动态导入 SDK
// const { WebInterfaceSdk } = await import('@byted-sdk/account-api');
import { WebInterfaceSdk } from "@byted-sdk/account-api";
import store from "@/store";

// 获取当前语言的辅助函数（延迟获取，避免在模块加载时访问 store）
const getCurrentLang = () => {
  // 如果 store 或 state 未初始化，从 localStorage 获取
  if (!store || !store.state || !store.state.user) {
    const lang = localStorage.getItem(process.env.VUE_APP_LANGURAGE as string);
    return lang === "en-US" ? "en" : "zh-Hans";
  }
  return store.state.user.currentLanguage === "en-US" ? "en" : "zh-Hans";
};

// 创建实例
const instance = new WebInterfaceSdk({
  aid: 491147, // 应用 ID
  host: "https://www.tiktokforbusiness-learning-center.com", // 主机地址
  isOversea: true, // 是否海外版本
  did: "0", // 设备 ID
  region: "sg", // 区域 (va/sg/ttp/gcp 等)
  printLog: true, // 是否打印日志
  pageLang: getCurrentLang(), // 页面语言
  language: getCurrentLang(), // 验证码语言
  starlingZoneHost: "https://starling-sg.tiktokv.com", // Starling zone host

  //【optional】 验证码配置，内部会带一个captcha的SDK，用来处理出现captcha的情况，如果要单独配置captcha，可以在这里传参。
  captchaOptions: {
    fpCookieOption: {
      domain: ".tiktokforbusiness-learning-center.com",
      sameSite: "None",
      secure: true,
    },
  },

  // 【optional】 通用参数
  generalParams: {
    multi_login: 1,
    did: "0",
    locale: getCurrentLang(),
    app_language: getCurrentLang(),
  },
  acrawler: "true",
  acrawlerUrl: "https://sf16-secsdk.ibytedtos.com/obj/rc-web-sdk-sg/webmssdk/1.0.0.303/webmssdk.js",
  sdi: true
});
export default instance;
